import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Zgłoś tę stronę',
  title: 'Zgłoś problem z tą stroną',
  reasons: {
    'inaccurate-or-fabricated': 'Nieprawdziwe lub zmyślone informacje',
    'wrong-product': 'Produkty nie pasują do strony',
    'sexually-explicit': 'Treści o charakterze seksualnym',
    'regulated-product': 'Produkt na receptę lub objęty regulacjami',
    'dangerous-product': 'Niebezpieczny produkt',
    'ip-infringement': 'Narusza moje prawa (znak towarowy/prawa autorskie)',
    other: 'Coś innego',
  },
  detail: 'Szczegóły (opcjonalnie)',
  submit: 'Wyślij zgłoszenie',
  cancel: 'Anuluj',
  sent: 'Dziękujemy. Zgłoszenia sprawdzamy w ciągu 24 godzin.',
  failed: 'Nie udało się wysłać zgłoszenia. Spróbuj ponownie.',
};
